import React, { useState } from "react";
import CorridorStatus from "./CorridorStatus";
import RecentChanges from "./RecentChanges";
import ActiveAlerts from "./ActiveAlerts";
import { useTimeFilter } from "../../contexts/TimeFilterContext";

function SectionTitle({ children }) {
  return (
    <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
      {children}
    </p>
  );
}

function Divider() {
  return <hr className="border-gray-100 dark:border-white/10" />;
}

export default function SummaryPanel({ isadData, onSegmentFocus }) {
  const [collapsed, setCollapsed] = useState(false);
  const { mode } = useTimeFilter();

  if (collapsed) {
    return (
      <aside className="flex shrink-0 flex-col items-center rounded-xl border border-gray-300 bg-white py-3 shadow-sm dark:border-white/40 dark:bg-navy-800 md:w-10">
        <button
          onClick={() => setCollapsed(false)}
          className="mb-2 text-gray-400 hover:text-gray-600 dark:hover:text-white"
          aria-label="Expand summary panel"
        >
          ‹
        </button>
        <span
          className="text-xs font-semibold text-gray-400 dark:text-gray-500"
          style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
        >
          Summary
        </span>
      </aside>
    );
  }

  return (
    <aside className="flex w-full shrink-0 flex-col overflow-hidden rounded-xl border border-gray-300 bg-white shadow-sm dark:border-white/40 dark:bg-navy-800 md:w-[320px]">
      <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-white/10">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-navy-700 dark:text-white">
            Corridor Summary
          </span>
          {mode === "historical" && (
            <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700 dark:bg-amber-900/30 dark:text-amber-400">
              Historical
            </span>
          )}
        </div>
        <button
          onClick={() => setCollapsed(true)}
          className="text-gray-400 hover:text-gray-600 dark:hover:text-white"
          aria-label="Collapse summary panel"
        >
          ›
        </button>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="space-y-4 p-4">
          <div>
            <SectionTitle>Corridor Status</SectionTitle>
            <CorridorStatus isadData={isadData} />
          </div>

          <Divider />

          <div>
            <SectionTitle>Recent Changes</SectionTitle>
            <RecentChanges onItemClick={onSegmentFocus} />
          </div>

          <Divider />

          <div>
            <SectionTitle>Active Alerts</SectionTitle>
            <ActiveAlerts />
          </div>
        </div>
      </div>
    </aside>
  );
}
